import { forwardRef } from 'react'
import { Chip } from '@/components/commons/chip'
import { GalleryImageItem } from '@/components/commons/gallery-image-item'
import type { RemapExperienceForViewOnly } from '@/features/experience-view-only/types'
import { useTranslation } from '@/translations/i18n'
import { Content, NoneValue } from './atoms'

export const PhotosStep = forwardRef<
	HTMLDivElement,
	{ experience: RemapExperienceForViewOnly }
>(({ experience }, ref) => {
	const { t } = useTranslation()
	const gallery = experience.gallery?.images
	return (
		<Content
			columns={5}
			gap={gallery.length > 0 ? 8 : 4}
			ref={ref}
			title={t('experience_shell:step_photos')}
		>
			{gallery.length > 0 ? (
				gallery.map((image) => (
					<GalleryImageItem
						key={image.id}
						src={image.url}
						topLeftSlot={
							image.isCover && (
								<Chip
									label={t('experience_shell:cover')}
									shape={'roundedRectangle'}
									variant={'neutral'}
								/>
							)
						}
					/>
				))
			) : (
				<NoneValue>{t('common:none')}</NoneValue>
			)}
		</Content>
	)
})

PhotosStep.displayName = 'PhotosStep'
